import { Component, Input, computed, inject, signal } from '@angular/core';
import { ThemeService } from '../../../core/services/theme.service';

/**
 * The small brand lockup used in the footer and on the staff login card.
 *
 * The *travelling* logo — hero to nav — is not this component: it is a single
 * <img> owned by the nav bar (see `nav-bar.component` and `HeroLogoService`),
 * because it has to be one element to move between the two.
 *
 * If the logo file is ever missing this falls back to a typographic lockup, so
 * nothing renders as a broken image.
 */

@Component({
  selector: 'app-brand-mark',
  standalone: true,
  templateUrl: './brand-mark.component.html',
  styleUrl: './brand-mark.component.scss',
})
export class BrandMarkComponent {
  /** 'compact' for bars, 'stacked' for the login card. */
  @Input() variant: 'compact' | 'stacked' = 'compact';

  /** Render nothing rather than the typographic fallback. */
  @Input() hideFallback = false;

  private readonly theme = inject(ThemeService);
  private readonly broken = signal(false);

  readonly src = computed(() => (this.broken() ? null : this.theme.logoSrc()));

  onError(): void {
    this.broken.set(true);
  }
}
